import { QueryOptions } from "../../components/Common/useQuery";
import useKaEmployeeQuery from "../../components/Common/useKaEmployeeQuery";

export interface IntegrationDto {
  id: string;
  name: string;
}

const useGetIntegrations = (options?: QueryOptions<IntegrationDto[]>) => {
  return useKaEmployeeQuery<IntegrationDto[]>({ path: '/employeeApi/integrations' }, options);
}

export default useGetIntegrations;
